/**
 * 往页面中插入css
 * @author chenguanbin
 * @param {String} path CSS文件路径
 * @param {String} name 包名称
 */
function loadCss (path, name) {
  return new Promise((resolve, reject) => {
    let head = document.getElementsByTagName('head')[0]
    let linkId = `skin-${name}`
    let linkTag = document.getElementById(linkId)
    linkTag && linkTag.parentNode.removeChild(linkTag)
    linkTag = document.createElement('link')
    linkTag.href = path
    linkTag.rel = 'stylesheet'
    linkTag.type = 'text/css'
    linkTag.setAttribute('id', linkId)
    linkTag.onload = () => resolve()
    linkTag.onerror = err => reject(err)
    head.appendChild(linkTag)
  })
}

export default loadCss
